import { ShieldCheck, Award } from "lucide-react";

/**
 * ServicePublicStrip — Fine barre institutionnelle affichée au-dessus du header.
 * S'inspire du style des sites gouv.fr pour renforcer l'aspect officiel.
 */
export default function ServicePublicStrip() {
  return (
    <div
      data-testid="service-public-strip"
      className="fixed top-0 inset-x-0 z-[60] bg-gradient-to-r from-[#0A0F1A] via-[#0F172A] to-[#0A0F1A] text-white/85 border-b border-white/5"
    >
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 h-8 flex items-center justify-between text-[10.5px] sm:text-[11px] tracking-wide">
        <div className="flex items-center gap-2 sm:gap-4 min-w-0">
          {/* Cocarde tricolore */}
          <div className="flex items-center gap-0.5 flex-shrink-0" aria-hidden="true">
            <span className="inline-block h-2.5 w-2.5 rounded-full bg-[#0055A4]" />
            <span className="inline-block h-2.5 w-2.5 rounded-full bg-white" />
            <span className="inline-block h-2.5 w-2.5 rounded-full bg-[#EF4135]" />
          </div>
          <span className="font-semibold uppercase tracking-[0.14em] hidden sm:inline">
            Mandataire officiel · MaPrimeRénov&apos; · Anah · CEE
          </span>
          <span className="font-semibold uppercase tracking-[0.14em] sm:hidden">
            Mandataire MPR · Anah · CEE
          </span>
        </div>
        <div className="hidden md:flex items-center gap-4 text-white/70 flex-shrink-0">
          <span className="inline-flex items-center gap-1.5">
            <Award className="h-3 w-3 text-[#10B981]" />
            <span>Qualibat RGE</span>
          </span>
          <span className="inline-flex items-center gap-1.5">
            <ShieldCheck className="h-3 w-3 text-[#10B981]" />
            <span>QualiPAC</span>
          </span>
          <span className="text-white/50">Anah · France Rénov&apos;</span>
        </div>
      </div>
    </div>
  );
}
